import { RESOLUTION_ID } from '../../../constants';
import Custom from './custom/custom';
import Exchange from './exchange/exchange';
import Refund from './refund/refund';
import { IResolutionTypeProps } from './resolution-type-viewer-props';



import './resolution-type-viewer.scss';


const ResolutionTypeViewer: React.FC<IResolutionTypeProps> = ({ resolution, validationGroup }) => {
    let Component = null;  
    if (resolution) {
        switch (resolution?.resolutionId) {
            case RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE:
            case RESOLUTION_ID.PRODUCT_EXCHANGE:
                Component = Exchange;
                break;
            case RESOLUTION_ID.MANUAL_EXCHANGE:
                Component = Custom;
                break;
            case RESOLUTION_ID.REFUND_TO_CREDIT:
            case RESOLUTION_ID.REFUND_TO_PLATFORM_STORE_CREDIT:
            case RESOLUTION_ID.ORIG_PAY_REFUND:
            case RESOLUTION_ID.REFUND_TO_BANK:
            case RESOLUTION_ID.INSTANT_REFUND:
            case RESOLUTION_ID.SHIP_LATER:
            case RESOLUTION_ID.KEEP:
            case RESOLUTION_ID.DONATE:
            case RESOLUTION_ID.REFUND_TO_GIFT_CARD:
                Component = Refund;
                break;
            case RESOLUTION_ID.CANCEL_ORDER:
                Component = Custom;
                break;
            default:
                throw new Error('not implemented resolution id');
        }
    }

    return (
        <div className={`resolution-viewer`}>
            {
                Component && <Component resolution={resolution} validationGroup={validationGroup} />
            }
        </div>
    )
}

export default ResolutionTypeViewer;